module.exports = __webpack_public_path__ + "img/popup-icon-blue.8295d519.svg";